import { useAtom, useAction } from "@reatom/npm-react";
import { useEffect } from "react";
import { getMeRequest } from "src/store/fetchers";

import { getCertInfo } from "../../../store/fetchers/getCertInfo.ts";

const ACCESS_COST = 15;

export const useCertInfo = (certNo: string) => {
  const [userInfo] = useAtom(getMeRequest.dataAtom);
  const [certInfo, setCertInfo] = useAtom(getCertInfo.dataAtom);
  const [isLoading] = useAtom(getCertInfo.isLoadingAtom);
  const loadCertInfo = useAction(getCertInfo);
  const hasMoney = (userInfo?.credit ?? 0) > ACCESS_COST;

  useEffect(() => {
    if (certNo && hasMoney) loadCertInfo(certNo);

    return () => {
      setCertInfo(null);
    };
  }, [hasMoney, loadCertInfo, setCertInfo, certNo]);

  return { certInfo, isLoading, hasMoney };
};
